<template>
  <div>
    <AllCases
      :priorityFlag="true"
      :selectedStatuses="statuses"
    ></AllCases>
  </div>
</template>

<script>
const AllCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    AllCases,
  },
  data() {
    return {
      statuses: ["ACTIVE", "TEST_REPORTS"],
    };
  },
};
</script>
